<template>
  <LayoutContainer>
    <Header />
    <main class="flex-1">
      <slot />
    </main>
    <Footer class="dark-mode" />
  </LayoutContainer>
</template>
